import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfig } from '../app-config';
import { APP_CONFIG } from '../app-config.token';
import { GenerateEmploymentCertificateRequest } from '../contracts/requests/generate-employment-certificate-request';
import { GenerateHolidayChildCareRequest } from '../contracts/requests/generate-holiday-child-care-request';
import { GeneratePaySlipRequest } from '../contracts/requests/generate-pay-slip-request';
import { GeneratePIT2Request } from '../contracts/requests/generate-pit2-request';
import { GeneratePpkCancellationRequest } from '../contracts/requests/generate-ppk-cancellation-request';
import { GenerateForeignWorkerDeclarationRequest } from '../contracts/requests/generate-foreign-worker-declaration-request';
import DocumentListDto from '../models/document-list-dto';
import { ViewLegalizationDto } from '../models/dtos/legalization-document-files-dto';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  private http = inject(HttpClient);
  private config = inject<AppConfig>(APP_CONFIG);

  private readonly API_URL = this.config.resourceApiURI + '/documents';

  constructor() { }

  getDocumentsByWorkerId(workerId: number): Observable<DocumentListDto[]> {
    return this.http
      .get<DocumentListDto[]>(this.API_URL + '/' + workerId);
  }

  getDocumentFile(documentId: number, fileId: number): Observable<string> {
    return this.http.get<string>(`${this.API_URL}/${documentId}/files/${fileId}`);
  }

  generateEmploymentCertificateFile(request: GenerateEmploymentCertificateRequest): Observable<any> {
    const url = `${this.API_URL}/employment/generate`;
    return this.http.post<any>(url, request);
  }

  generatePaySlipFile(request: GeneratePaySlipRequest): Observable<any> {
    const url = `${this.API_URL}/paySlip/generate`;
    return this.http.post<any>(url, request);
  }

  generatePIT2File(request: GeneratePIT2Request): Observable<any> {
    const url = `${this.API_URL}/PIT2/generate`;
    return this.http.post<any>(url, request);
  }

  generateHolidayChildCareFile(request: GenerateHolidayChildCareRequest): Observable<number> {
    const url = `${this.API_URL}/HolidayChildCare/generate`;
    return this.http.post<number>(url, request);
  }

  generatePpkCancelationFile(request: GeneratePpkCancellationRequest): Observable<number> {
    const url = `${this.API_URL}/PpkCancelation/generate`;
    return this.http.post<number>(url, request);
  }

  generateForeignWorkerDeclarationFile(request: GenerateForeignWorkerDeclarationRequest): Observable<number> {
    const url = `${this.API_URL}/ForeignWorkerDeclaration/generate`;
    return this.http.post<number>(url, request);
  }
  getLegalizationDocumentsByWorkerId(workerId: number, onlyActive?: boolean): Observable<ViewLegalizationDto[]> {
    const url = `${this.API_URL}/${workerId}/legalizationDocuments`;
    const params = onlyActive !== undefined ? { onlyAcitve: onlyActive.toString() } : {};
    return this.http
      .get<ViewLegalizationDto[]>(url, { params });
  }
}
